import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=8e8d250c"
import script from "./ChannelList.vue?vue&type=script&lang=ts"
export * from "./ChannelList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports